/**
 * Helpers para checagem de permissões no objeto usuário retornado pelo login
 * (roles + permissions mescladas de todas as roles).
 */

export function userHasPermission(user, permissionName) {
  if (!user || !permissionName) {
    return false
  }
  if (userHasRole(user, 'super')) {
    return true
  }
  if (!Array.isArray(user.permissions)) {
    return false
  }
  return user.permissions.some((p) => p && p.name === permissionName)
}

export function userHasRole(user, roleName) {
  return Boolean(user && Array.isArray(user.roles) && user.roles.some((role) =>
    role && String(role.name || '').toLowerCase() === String(roleName || '').toLowerCase()
  ))
}

export function userHasAnyPermission(user, permissionNames = []) {
  if (!Array.isArray(permissionNames) || permissionNames.length === 0) {
    return false
  }
  return permissionNames.some((permissionName) =>
    userHasPermission(user, permissionName)
  )
}

/**
 * Pode ver/editar valor do atendimento, repasse e coparticipação (telas de atendimento)
 * e ver valores não mascarados na listagem.
 * Perfis super, admin e financial continuam com acesso total; demais usuários
 * dependem da permissão atendimento.edit.valores (configurável por empresa).
 */
export function canEditAttendanceMoneyFields(user) {
  if (!user) {
    return false
  }
  const roles = user.roles || []
  if (
    roles.some(
      (r) =>
        r &&
        (r.name === "super" || r.name === "admin" || r.name === "financial")
    )
  ) {
    return true
  }
  return userHasPermission(user, "atendimento.edit.valores")
}

/**
 * Gráficos e blocos do dashboard com métricas financeiras / agregadas sensíveis.
 * Alinhado ao backend (DashboardController::userCanSeeDashboardSensitiveMetrics).
 */
export function userHasDashboardSensitiveAnalytics(user) {
  return userHasAnyPermission(user, [
    "dashboard.cards.statistics.view",
    "dashboard.cards.revenue-analytics.view",
    "dashboard.cards.sales-analytics.view",
    "dashboard.cards.earning-report.view",
    "dashboard.cards.recent-activity.view",
    "dashboard.cards.transaction.view",
  ])
}

export function userCanViewDashboardBlock(user, permissionName) {
  return userHasPermission(user, permissionName)
}

/**
 * Pode visualizar evolução (parecer) do paciente na agenda principal.
 * Super ignora checagem (alinhado ao authGuard / Gate::before).
 */
export function userCanViewAgendaEvolution(user) {
  if (!user) {
    return false
  }
  const roles = user.roles || []
  if (roles.some((r) => r && r.name === 'super')) {
    return true
  }
  return userHasPermission(user, 'agenda.recurrence.view')
}
